import { Dot } from "@xola/ui-kit";
import React from "react";
import { LineItem, LineItemType } from "types";
import { RowData } from "./types";
import { AutoTooltipContainer } from "@/components/Common/AutoTooltipContainer";

export const addOnsPickUpCellValueGetter = ({ data }: { data: RowData }) => {
    if (!data || "balance" in data) {
        return null;
    }

    const pickupLineItemsAddOns = data.isOrganizer
        ? data.item?.lineItems.filter((lineItem) => lineItem.type === LineItemType.PICKUP)
        : null;

    return pickupLineItemsAddOns;
};

interface AddOnsPickUpCellRendererProps {
    value: LineItem[] | null;
    data: RowData;
    node: any;
    headerName: string;
}

export const AddOnsPickUpCellRenderer = ({ value, data, node, headerName }: AddOnsPickUpCellRendererProps) => {
    const pickUpAnswer = value?.find((lineItem) => lineItem?.name?.split(":")?.[0] === headerName)?.name.split(":")[1];

    if (node.expanded && node.key === "summary" && "addOns" in data && data.addOns && data.addOns.value) {
        const filteredEntries = Object.entries(data.addOns.value).filter(([key]) => key.startsWith(headerName + ":"));

        const optionNamesAndValues: { [key: string]: number } = {};

        for (const [key, value] of filteredEntries) {
            const newKey = key.split(":")[1].trim();
            optionNamesAndValues[newKey] = (optionNamesAndValues[newKey] || 0) + value;
        }

        const resultKeys = Object.keys(optionNamesAndValues);

        return (
            <ul className="no-translate pt-2 leading-5">
                {resultKeys.map((name: string) => (
                    <li key={name} className="flex items-center space-x-1" data-testid="roster-guest-list-addons-item">
                        <div className="w-[calc(100%-5px)]">
                            <AutoTooltipContainer tooltipContent={`${optionNamesAndValues[name]} ${name}`}>
                                <Dot className="mr-1 flex-shrink-0 bg-black" />
                                <span>
                                    {optionNamesAndValues[name]} {name}
                                </span>
                            </AutoTooltipContainer>
                        </div>
                    </li>
                ))}
            </ul>
        );
    }

    if (!pickUpAnswer) return null;

    return (
        <div>
            <AutoTooltipContainer tooltipContent={pickUpAnswer}>
                <span>
                    <span>{pickUpAnswer} </span>
                </span>
            </AutoTooltipContainer>
        </div>
    );
};
